/*
 * @Author: 朱廷果 1028509503@qq.com
 * @Date: 2022-11-09 14:41:38
 * @LastEditors: 朱廷果 1028509503@qq.com
 * @LastEditTime: 2023-01-10 11:36:50
 * @FilePath: \saas_front\src\apis\saas\saas.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/apis/data/saasRequest.js'
import { dataInterface } from './data/saasMapi'
// 获取市场模板左侧菜单
export function saasInterface(data, url, method = 'POST') {
  return dataInterface(
    data,url,method)
}
export function getTempMenuList(data) {
  return request({
    url: '/api/saas/appsList',
    method: 'post',
    data
  })
}
// 通过token直接进入
export function userInfo(data) {
  return request({
    url: 'api/saas/userInfo',
    method: 'get',
    params:{
      data
    }
  })
}
// 判断token是否过期
export function tokenExpire(data) {
  return request({
    url: 'api/saas/tokenExpire',
    method: 'post',
    data
  })
}
// 安装模板市场应用
export function installApp(data) {
  return request({
    url: '/api/saas/installApp',
    method: 'post',
    data,}
    )
}
// 文档中心筛选内容的接口
export function getRepositoryTypeList(data) {
  return request({
    url: 'api/saas/app/repositoryTypeList',
    method: 'post',
    data
  })
}
// 菜单授权更改权限
export function repositoryList(data) {
  return request({
    url: 'api/saas/app/repositoryList',
    method: 'post',
    data
  })
}

/**
 * @desc 判断我的应用是否安装
 * @data 数组id
 */
 export function appInstallStatus(data) {
  return request({
    url: 'api/saas/appInstallStatus',
    method: 'post',
    data: {
      ...data,
    }
  })
}